import * as React from "react";
import type { SVGProps } from "react";
const SvgRenovatedIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M4 2c-.547 0-1 .453-1 1v6c0 .547.453 1 1 1h19.5c.547 0 1-.453 1-1V6.5h.5v4.594l-11.11 2.422a.5.5 0 0 0-.39.484v2h-1c-.547 0-1 .453-1 1v8c0 .547.453 1 1 1h3c.547 0 1-.453 1-1v-8c0-.547-.453-1-1-1h-1v-1.594l11.11-2.422A.5.5 0 0 0 26 11.5V6c0-.275-.225-.5-.5-.5h-1V3c0-.547-.453-1-1-1zm0 1h19.5v2.844c-.03.097-.03.199 0 .297V9H4zm8.5 14h3v8h-3z"
    />
  </svg>
);
export default SvgRenovatedIcon;
